import api from "../../http";
import { toApiError } from "../utils";
import type { AgriculturalDefensive } from "@practium/features/products";

export type ImportDefensiveParams = {
    file: File;
};

export type ImportedAgriculturalDefensive = Omit<
    AgriculturalDefensive,
    "activeIngredients" | "manufacturer"
> & {
    activeIngredients?: {
        name: string;
        concentration: number;
        _id?: string;
    }[];
    manufacturer: string | AgriculturalDefensive["manufacturer"];
    createdAt?: string;
    updatedAt?: string;
    __v?: number;
};

export type DefensiveImportResponse = {
    created: number;
    totalRows: number;
    errors: {
        row: number;
        message: string;
    }[];
    agriculturalDefensives: ImportedAgriculturalDefensive[];
};

export async function importDefensiveFile({
    file
}: ImportDefensiveParams): Promise<DefensiveImportResponse> {
    const formData = new FormData();

    formData.append("file", file);

    try {
        const response = await api.post("/agricultural-defensives/import", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        });

        return response.data;
    } catch (error) {
        throw toApiError(error, "Erro ao importar defensivos");
    }
}
